import { ThemeProvider, createTheme, styled } from "@mui/material/styles";
import { DataGrid, GridPagination } from "@mui/x-data-grid";
const MuiTheme = createTheme();
export const CustomFooter = (props) => {
  return (
    <>
      <div className="flex flex-row gap-0 h-[40px] items-center justify-end border-t border-gray-300">
        <GridPagination
          sx={{
            ".MuiToolbar-root": {
              fontSize: "12px",
            },
            "& .MuiTablePagination-displayedRows": {
              fontSize: "14px",
              color: "#9CA3AF",
            },
            "& .MuiSvgIcon-root": {
              fontSize: "18px",
            },
          }}
        />
      </div>
    </>
  );
};
const StyledDataGrid = styled(DataGrid)({
  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "#1a174e",
    textTransform: "uppercase",
    fontSize: "12px",
    color: "#FFFFFF",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: "600 !important",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  },
  "& .MuiDataGrid-cell": {
    borderColor: "#EDF2F7",
  },
  "& .MuiDataGrid-row": {
    color: "#3E3C42",
    fontSize: "12px",
    fontFamily: "Roboto, sans-serif",
    "&:hover": {
      cursor: "pointer",
      backgroundColor: "#F5F5F5",
    },
  },
  "& .css-9vna8i-MuiButtonBase-root-MuiIconButton-root": {
    color: "white !important",
  },
  "&.MuiDataGrid-root": {
    border: "none",
    fontSize: "12px",
  },
});
export const CustomStyledDataGrid = (props) => {
  return (
    <ThemeProvider theme={MuiTheme}>
      <StyledDataGrid {...props} />
    </ThemeProvider>
  );
};
